module.exports = "<app-nav-tab></app-nav-tab>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/submaster/submaster.component.html
// module id = ./src/app/components/submaster/submaster.component.html
// module chunks = main